import { Field, Select } from "@/components/FormField";
import { CUSTOMER_TYPES } from "../constants";

export default function ContactDetails({ form, upd }) {
  return (
    <div>
      <div className="font-serif-display text-xl text-[var(--yp-primary)]">Your details</div>
      <p className="text-sm text-[var(--yp-muted)] mt-1">Start with the person we should speak with about the visit.</p>
      <div className="grid sm:grid-cols-2 gap-4 mt-5">
        <Field id="sr-name" label="Full name" required value={form.full_name} onChange={(v) => upd("full_name", v)} />
        <Field id="sr-phone" label="Mobile number" required value={form.phone} onChange={(v) => upd("phone", v.replace(/\D/g, "").slice(0, 10))} />
        <Field id="sr-whatsapp" label="WhatsApp number" value={form.whatsapp} onChange={(v) => upd("whatsapp", v.replace(/\D/g, "").slice(0, 10))} />
        <Field id="sr-email" label="Email address" type="email" value={form.email} onChange={(v) => upd("email", v)} />
        <Select id="sr-customer-type" label="I am a" required value={form.customer_type} onChange={(v) => upd("customer_type", v)} options={CUSTOMER_TYPES} />
        <Field id="sr-company" label="Company / organisation" value={form.company} onChange={(v) => upd("company", v)} />
      </div>
    </div>
  );
}
